import { USER_ROLES } from './auth.config';

/**
 * Retrieves the matching role from returned list from auth service
 *
 * @param {array} roles - A list of roles
 */
const mapUserRole = (roles) => {
	return roles.filter((role) => Object.values(USER_ROLES).includes(role));
};

/**
 * Returns if user is authorized for a given role
 *
 * @param {array} roles - A list of roles
 * @param {string} roleExpected - Role expected
 */
const isAuthorized = (roles, roleExpected) => {
	return roles.some((role) => role === roleExpected);
};

export { USER_ROLES, mapUserRole, isAuthorized };
